import React, { useEffect, useRef, useState } from 'react';
import { BsFillCaretDownFill } from 'react-icons/bs';
import CircleNotificationsIcon from '@mui/icons-material/CircleNotifications';
import MenuBookIcon from '@mui/icons-material/MenuBook';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import SupportAgentIcon from '@mui/icons-material/SupportAgent';
import { UserProfile, IconButton, UserManualModal } from 'src/components';

import styles from './Header.module.scss';

import logo from 'src/assets/images/tata-motors-logo.jpg';
import sadhanLogo from 'src/assets/images/icons/sadhan-logo.svg';
import { Badge } from '@mui/material';
import Stack from '@mui/material/Stack';
import { useNavigate } from 'react-router-dom';
import { hasEditAccess } from 'src/authorization/authorizationsConstants';
import useAuthorizationContext from 'src/providers/AuthorizationHandler/useAuthorizationContext';
import { useSelector } from 'react-redux';
import config from 'src/config/config';
import { HelpAndSupport } from '../Atoms/HelpAndSupport';
import { commonVaribles } from 'src/constants/constVariables';
import { packaging_strategy_all_endpoints } from 'src/constants/url';
import { baseApiCall } from 'src/api/Api';

export const Header = (props) => {
	const { API_BASE_URL } = config;

	const navigate = useNavigate();
	const { user } = useAuthorizationContext();
	const [showProfile, setShowProfile] = useState(false);
	const [showHelpAndSupport, setShowHelpAndSupport] = useState(false);
	const [showManual, setShowManual] = useState(false);
	const [manualPdfUrl, setmanualPdfUrl] = useState('');
	const profileRef = useRef(null);
	const HelpAndSupportRef = useRef(null);
	const [ismodalLoader, SetModalloader] = useState(false);

	const alertsCount = useSelector((state) => state.user.alertCount);

	const renderTestWaterMark = () => (
		<span className={styles.testTitle}>
			<strong>TEST ENVIRONMENT</strong>
			Changes made here will not impact/influence actual Production
		</span>
	);

	const fetchUserManualFile = () => {
		SetModalloader(true);
		const requestBody = {
			file_name: commonVaribles.user_manual_file_name,
			img_type: commonVaribles.user_manual_folder,
		};
		baseApiCall({
			url: packaging_strategy_all_endpoints.GET_PRESIGNED_IMAGES,
			requestBody: requestBody,
			method: commonVaribles.post,
			onSuccess: (res) => {
				if (res?.data?.result) {
					setmanualPdfUrl(res?.data?.result);
					SetModalloader(false);
				} else {
					setmanualPdfUrl('');
				}
			},
			onFailure: () => {
				SetModalloader(false);
			},
			errorCall: () => {
				SetModalloader(false);
			},
		});
	};

	useEffect(() => {
		if (showManual) {
			fetchUserManualFile();
		}
	}, [showManual]);

	return (
		<div className={styles.header} {...props}>
			<div className={styles.leftContainer}>
				<img className={styles.logo} src={logo} alt="Tata Motors" />
			</div>
			<div>
				{ API_BASE_URL.includes('dev') && renderTestWaterMark()}
			</div>
			<div className={styles.rightContainer}>
				<div className={styles.topIcons}>
					<Stack spacing={2} direction="row">
						<MenuBookIcon
							onClick={() => {
								setShowManual(true);
							}}
						/>
						{/* <WarningAmberIcon color="primary" /> */}
						<SupportAgentIcon ref={HelpAndSupportRef} color="primary" onClick={() => setShowHelpAndSupport(true)} />
						{hasEditAccess(user, 'alerts') && (
							<div
								onClick={() => {
									navigate('/alerts');
								}}
							>
								<Badge
									badgeContent={alertsCount ? alertsCount : 0}
									color="error"
									max={99}
								>
									<CircleNotificationsIcon color="primary" />
								</Badge>
							</div>
						)}
						<AccountCircleIcon />
					</Stack>
					<IconButton
						className={styles.iconButton}
						ref={profileRef}
						onClick={() => setShowProfile(true)}
					>
						<BsFillCaretDownFill style={{ marginRight: 0 }} />
					</IconButton>
				</div>
				<div className={styles.esakhaContainer}>
					<a href={'/'} className={styles.homeLink}>
						<span>
							<img
								src={sadhanLogo}
								className={styles.sadhanLogo}
								alt="Sadhan"
							/>
						</span>
					</a>
				</div>
			</div>
			<UserProfile
				open={showProfile}
				anchorEl={profileRef.current}
				handleClose={() => setShowProfile(false)}
			/>
			<HelpAndSupport
				open={showHelpAndSupport}
				anchorEl={HelpAndSupportRef.current}
				handleClose={() => setShowHelpAndSupport(false)}
			/>
			<UserManualModal
				open={showManual}
				handleClose={() => {setShowManual(false)}}
				Modalloader={ismodalLoader}
				PdfUrl={manualPdfUrl}
				title={'User Manual'}
			/>
		</div>
	);
};
